import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <header
      className={`fixed left-0 right-0 z-50 transition-all duration-300 bg-dark-surface/95 backdrop-blur-lg shadow-lg ${
        isScrolled ? 'bg-dark-surface/95 backdrop-blur-lg shadow-lg' : 'bg-transparent'
      }`}
      style={{ top: 'var(--warning-banner-height, 2rem)' }}
    >
      <nav className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2">
            <img
              src="/images/logo.webp"
              alt="BetSprinto"
              className="h-10 w-auto"
              loading="eager"
              width="40"
              height="40"
            />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`transition-colors ${
                isActive('/') ? 'text-accent-primary' : 'text-gray-300 hover:text-accent-primary'
              }`}
            >
              Accueil
            </Link>
            <Link
              to="/comparaison"
              className={`transition-colors ${
                isActive('/comparaison')
                  ? 'text-accent-primary'
                  : 'text-gray-300 hover:text-accent-primary'
              }`}
            >
              Comparaison
            </Link>
            <Link
              to="/a-propos"
              className={`transition-colors ${
                isActive('/a-propos')
                  ? 'text-accent-primary'
                  : 'text-gray-300 hover:text-accent-primary'
              }`}
            >
              À propos
            </Link>
            <Link
              to="/faq"
              className={`transition-colors ${
                isActive('/faq') ? 'text-accent-primary' : 'text-gray-300 hover:text-accent-primary'
              }`}
            >
              FAQ
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-300 hover:text-accent-primary transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-4 animate-fade-in">
            <Link
              to="/"
              className="block text-gray-300 hover:text-accent-primary transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Accueil
            </Link>
            <Link
              to="/comparaison"
              className="block text-gray-300 hover:text-accent-primary transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Comparaison
            </Link>
            <Link
              to="/a-propos"
              className="block text-gray-300 hover:text-accent-primary transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              À propos
            </Link>
            <Link
              to="/faq"
              className="block text-gray-300 hover:text-accent-primary transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              FAQ
            </Link>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;

